import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataInscricaoTcc = (): TabelaColuna => ({
  Chave: 'dataInscricaoTCC',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataInscricaoTCC)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Data Insc. TCC</div>
})
